import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import HospitalsHome from './pages/HospitalsHome';
import FireHome from './pages/FireHome'
import PoliceHome from './pages/PoliceHome'
import UsersData from "./pages/UsersData";
import Sensor from "./pages/Sensor";
import Register from "./cards/Register"
import Login from "./cards/Login"

const Main = () => {
    return (
        <Routes> {/* The Switch decides which component to show based on the current URL.*/}
            <Route path='/' element={<Home type="All"/>} />
            <Route path='/hospital' element={<HospitalsHome />} />
            <Route path='/fire' element={<FireHome />} />
            <Route path='/data' element={<UsersData />} />
            <Route path='/sensor' element={<Sensor />} />
            <Route path='/register' element={<Register />} />
            <Route path='/login' element={<Login />} />
            <Route path='/police' element={<PoliceHome />} />
        </Routes>
    );
}

export default Main;
